// ═══════════════════════════════════════════════════════════════════════════════
// Maintenance mode validation
// ═══════════════════════════════════════════════════════════════════════════════
import { z } from 'zod';
const hktDatetimeSchema = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/, 'Must be YYYY-MM-DD hh:mm (Asia/Hong_Kong)');
const maintenanceMessageSchema = z.object({
    'zh-Hant': z.string().max(2000).optional(),
    'zh-Hans': z.string().max(2000).optional(),
    en: z.string().max(2000).optional(),
});
export const updateMaintenanceModeInputSchema = z
    .object({
    enabled: z.boolean(),
    message: maintenanceMessageSchema.optional(),
    startAt: hktDatetimeSchema.nullable(),
    endAt: hktDatetimeSchema.nullable(),
    publicApiEnabled: z.boolean(),
    adminPortalEnabled: z.boolean(),
    cronEnabled: z.boolean(),
})
    .superRefine((data, ctx) => {
    if (data.enabled && (data.startAt == null || data.startAt.trim() === '')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'startAt is required when maintenance is enabled',
            path: ['startAt'],
        });
    }
    if (data.startAt && data.endAt && data.endAt <= data.startAt) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'endAt must be after startAt',
            path: ['endAt'],
        });
    }
});
//# sourceMappingURL=maintenance.schema.js.map